<template>
  <v-container class="contract-detail-page" fluid tag="section">
    <div  v-if="!data">
      <img :src="require('@/assets/images/empty.png')" height="200" width="100%"/>
    </div>
    <div v-else>
      <div class="contract" v-if="item && item.again === 1">
        <img :src="require('@/assets/images/contract.png')"/>
      </div>

      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" :sm='6' class="size-13 pb-1">
          客户名称：<span class="grey--text text--darken-1">{{data.customer === null || data.customer === undefined  ? '' : data.customer.name}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" sm='6' class="size-13 py-1">
          订单编号：<span class="grey--text text--darken-1">{{data.serialNumber}}</span>
          <v-chip x-small label class="ml-0 mt-n1 pa-1" outlined color="primary">
            {{data.year}}年<span v-if="bookkeeping">{{item.month}}月开始</span>
          </v-chip>
        </v-col>
        <v-col cols="12" :md="mini ? 6 : 4" sm='6' class="size-13 py-1">
          签订项目：
          <span class="grey--text text--darken-1">{{data.product === null || data.product === undefined ? '' : data.product.name}}</span>
        </v-col>
      </v-row>

      <v-row v-if="data.bookkeepingDic && data.bookkeepingDic.length > 0">
        <v-col cols="12" class="size-13 py-1">
          附加服务：
          <v-chip v-for="(item, idx) in data.bookkeepingDic" dark color="primary" small class="mr-1" :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" class="size-13 py-1">
          签订公司：<span class="grey--text text--darken-1">
            {{data.signDic  === null || data.signDic === undefined  ? '' : data.signDic.name}}
            <span v-if="data.channelName" class="grey--text text--darken-1">({{data.channelName}})</span>
          </span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          签订人员：
          <v-chip v-for="(item, idx) in data.signUserList" label x-small class="mr-1 pa-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          签订时间：<span class="grey--text text--darken-1">{{data.signTime | formatDay}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          {{bookkeeping ? '服务时长' : '签订数量'}}：<span class="grey--text text--darken-1">{{data.productNumber}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          产品定价：<span class="grey--text text--darken-1">{{data.unitPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          签单单价：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.signUnitPrice}}</span>
        </v-col>
      </v-row>

      <v-row v-if="data.signUnitPrice < data.unitPrice">
        <v-col class="size-13 py-1"><span class="grey--text text--darken-1 red--text">提示：本合同&nbsp;“签单单价”&nbsp;小于&nbsp;“产品定价“</span></v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          合同金额：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.signPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          合同状态：<span class="grey--text text--darken-1">{{data.stateDic  === null || data.stateDic === undefined  ? '' : data.stateDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          收费比例：<span class="grey--text text--darken-1">{{data.chargeRatio}}</span>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" :md="mini ? 6 : 8" class="size-13 py-1">
          合同类型：<span class="grey--text text--darken-1">{{data.typeDic  === null || data.typeDic === undefined  ? '' : data.typeDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          居间人员：<span class="grey--text text--darken-1">{{data.mediatorName}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          居间人费：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.mediatorPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          其他费用：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.otherPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          合同绩效：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.profitPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          人员级别：<span class="grey--text text--darken-1">{{data.levelDic  === null || data.levelDic === undefined   ? '' : data.levelDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          提成比例：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.commissionRatio}}%</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          提成金额：<span class="grey--text text--darken-1" v-if="showPrice(data.contactsPersonList)">{{data.ratioPrice}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          负责人员：
          <v-chip v-for="(item, idx) in data.contactsPersonList" label x-small class="mr-1 pa-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" class="size-13 py-1">
          协同人员 ：
          <v-chip v-for="(item, idx) in data.assistPersonList" label x-small class="mr-1 pa-1"  outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" class="size-13 py-1">
          合同版本：<span class="grey--text text--darken-1">v{{data.version}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="size-13 py-1">
          备注信息：<span class="grey--text text--darken-1">{{data.remark}}</span>
        </v-col>
      </v-row>
      <v-row v-if="showPrice(data.contactsPersonList)">
        <v-col cols="12" class="size-13 py-1">
          附件信息：
          <span v-if="data.fileName" class="grey--text text--darken-1">
            <v-btn text class="pl-0" color="primary" small @click="view(data.filePath)">
              {{data.fileName.substring(data.fileName.lastIndexOf('/')+1,data.fileName.length)}}
            </v-btn>
          </span>
          <span v-else class="grey--text text--darken-1">无附件信息</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
   </v-container>
</template>

<script>
  import { getById } from '@/api/contract/index.js'

  export default {
    name: 'ContractDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        data: this.item,
        fileModal: { show: false }
      }
    },
    methods: {
      loadData () {
        if (this.item && this.item.id) {
          this.loading = true
          getById(this.item.id).then(res => {
            if (res.status === 200) {
              this.data = res.data
            }
            this.loading = false
          })
        }
      },
      showPrice (list) {
        let boo = false
        list.forEach(p => {
          boo = p.id === this.$store.state.userInfo.id
        });
        return boo || this.$_has('con-contract-price') || this.$store.state.userInfo.roleIds.indexOf(1) !== -1
      },
      view (path) {
        if (path) {
          window.open(
            path,
            "_blank"
          );
        }
      }
    },
    computed: {
      bookkeeping () {
        return this.$constants.ProductType.Bookkeeping.indexOf(this.item.productId) !== -1
      }
    },
    created () {
      if (this.lazy) {
        this.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
.contract {
  position: absolute;
  z-index: 1;
  left: 270px;
  top: 55px;
  img{
    width: 120px;
    -moz-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}
</style>
